<template>
  <div id="AssetView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div class="right-asset-tab-list" v-if="loadTabView">
        <ul class="activetabs" id="tabActive">
          <li class="active"> <a href="javascript:void(0)" v-on:click="activetab = 0"> Asset Details </a> </li>
          <li v-if="allowAssetgroup === true && !hidefield"> <a href="javascript:void(0)" v-on:click="loadVehicleGroup(assetData.vehicle_group_id)"> Group </a> </li>
          <li v-if="allowListassetownership === true && !hidefield"> <a href="javascript:void(0)" v-on:click="ownershipTabClicked()" id="ownerShipTab"> Ownership </a> </li>
          <li v-if="tabMenuAssetDealer === true && hidefield" > <a href="javascript:void(0)" v-on:click="dealerTabClicked()"> Dealer </a> </li>
          <li v-if="tabMenuAssetConsumer === true && hidefield" > <a href="javascript:void(0)" v-on:click="consumerTabClicked()"> Customer </a> </li>
          <li v-if="allowLogasset === true && !hidefield"> <a href="javascript:void(0)" v-on:click="assetLogTabClicked()"> Asset Logs </a> </li>
          <!--<li id="activetab4"> <a href="javascript:void(0)" v-on:click="activetab=4"> Features </a> </li>-->
          <li v-if="allowAssetfeature === true && !hidefield" id="extraFeatureTab"> <a href="javascript:void(0)" v-on:click="extraFeaturesTabClicked()">Features </a> </li>
          <!-- <li> <a href="javascript:void(0)" v-on:click="standardFeatures()"> Standard Features </a> </li> -->
          <!-- <li> <a href="javascript:void(0)" v-on:click="loadAssetDefect()">  Defects </a> </li> -->
          <li v-if="allowAssetcomment === true && hidefield && canViewComment" id="activetab17"> <a href="javascript:void(0)" v-on:click="getCommentList()">Comments</a> </li>

          <li v-if="allowAssetpermit === true && !hidefield" id='permit'> <a href="javascript:void(0)" v-on:click="permitTabClicked()"> Permits </a> </li>
          <li v-if="allowAddodometerreading === true && !hidefield" id="assetTypeMeterTab"> <a href="javascript:void(0)" v-on:click="getAssetMeter()">Meter</a> </li>
          <li v-if="allowOdometerreadingreport === true && !hidefield"> <a href="javascript:void(0)" v-on:click="getReadingList()">Meter Metric</a> </li>
          <!-- <li> <a href="javascript:void(0)" v-on:click="contractHistoryTabClicked()"> Contract History </a> </li> -->
          <li v-if="allowListwarranty === true && !hidefield"> <a href="javascript:void(0)" v-on:click="assetWarranty()"> Coverage </a> </li>
          <li v-if="allowListwarranty === true" id="activetab24"> <a href="javascript:void(0)" v-on:click="warranties()"> Warranties </a> </li>
          <li v-if="allowPmunitdetailreport === true && !hidefield"> <a href="javascript:void(0)" v-on:click="pmDetail()"> PM Detail </a> </li>
          <!-- <li id="component-detail"> <a href="javascript:void(0)" v-on:click="loadList()"> Asset Components </a> </li> -->
          <!-- <li> <a href="javascript:void(0)" v-on:click="telematicsReadingTabClicked()"> Readings </a> </li> -->
          <li v-if="allowListcustomercontact === true && hidefield"> <a href="javascript:void(0)" v-on:click="customerContactTabClicked()"> Customer Contacts </a> </li>
          <li v-if="allowListrentalagreement === true && !hidefield"> <a href="javascript:void(0)" v-on:click="getCustomerAgreement()"> Agreements </a> </li>
          <li v-if="allowListcontractassetdetail === true && !hidefield"> <a href="javascript:void(0)" v-on:click="getContractAsset()"> Contract Asset </a> </li>
          <!-- <li> <a href="javascript:void(0)" v-on:click="componentWarranty()"> Component Warranty </a> </li> -->
          <li v-if="allowListworkorder === true && !hidefield" id='workOrder'> <a href="javascript:void(0)" v-on:click="workOrder()"> Work Orders</a> </li>
          <li v-if="allowGeneralledgerreport === true && !hidefield"> <a href="javascript:void(0)" v-on:click="capitalCostTab()"> Capital Cost GL</a> </li>
          <li v-if="allowListactivitylog === true && !hidefield"> <a href="javascript:void(0)" v-on:click="getActivityLog()">Activity Logs</a> </li>
          <li v-if="allowListprogram === true && !hidefield"> <a href="javascript:void(0)" v-on:click="loadProgramInterval(assetData)">Asset Interval Override</a> </li>
          <li v-if="allowListcapitalcost === true && !hidefield"> <a href="javascript:void(0)" v-on:click="getCapitalCost(assetData)">Capital Cost Analysis</a> </li>
          <li v-if="allowListCampaign === true" id="campaign"> <a href="javascript:void(0)" v-on:click="campaignRecalls()"> Campaign/Recall </a> </li>

        </ul>
      </div>
    <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
      <template v-if="cantAccessPage === true">
        <div class="page-name asset-view-page-name" v-if="vin != ''">
          <div class="page-title">{{vin}}</div>
          <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
          <div class="btn-groups text-right">
            <button type="submit" class="btn btn-secondary ml-1" v-if="(velocity_env == 'velev' || velocity_env == 'velev_test') && assetData.vsName == 'Sold'" v-on:click.prevent="downloadInv" >
                        <i class="fp-invoice"> </i> Invoice
            </button>
            <button type="submit" class="btn btn-secondary ml-1" v-if="(velocity_env == 'velev' || velocity_env == 'velev_test') && rows.length <= 0 && canGenerateVehicleWarranty" v-on:click.prevent="generateVehicleWarranty" >
              <i class="fp-warranty"> </i> Generate Warranty
            </button>
            <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="backButton" >
                        <i class="fp-back"> </i>    Back
            </button>

<!--            <router-link v-if="activetab === 0 && allowEditAsset" title="Edit Asset" class="btn btn-primary" v-bind:to="{name: 'AssetEdit',params:{id:assetData.id}}"><i class="fp-edit-icon"> </i> Edit</router-link>-->
          </div>
          <!-- <button type="submit" id="fetchWarranty" v-on:click="getWarranties" class="btn btn-success waves-effect pull-right">
            <i class="hi-icon icon-flAdd"> </i>  Fetch Warranty
          </button> -->
        </div>
        <div class="container-fluid">
          <div id="asset-detail" class="admin-page-content asset-view list-view" v-show="activetab == 0"><!--asset- detail-->
            <vehicle-details @vehicle-details-data="handleVehicleData"></vehicle-details>
          </div> <!--asset- detail-->
          <!--Ownership tab-->
          <div id="ownership" class="admin-page-content asset-view list-view" v-show="activetab == 10">
            <section class="internal-container border-top-table-fl">
                <app-asset-tab v-if="ownershipLoad"></app-asset-tab>
            </section>
          </div>
          <!--Ownership tab-->
          <!--Dealer tab-->
          <div id="dealer" v-show="activetab == 31">
                <app-asset-tab-dealer-view></app-asset-tab-dealer-view>
          </div>
          <!--Dealer tab-->
          <!--Consumer tab-->
           <div id="consumer" v-show="activetab == 32">
              <app-asset-tab-consumer-view></app-asset-tab-consumer-view>
          </div>
          <!--Consumer tab-->
          <div id="asset-logs" class="admin-page-content asset-view list-view" v-show="activetab == 18"> <!--Asset Logs-->
            <section class="internal-container border-top-table-fl">
                <app-asset-log-tab v-if="assetLogLoad" :assetLogVal="assetLogTabValue"></app-asset-log-tab>
            </section>
          </div> <!--Asset Logs-->
          <div id="defect-history" class="admin-page-content asset-view list-view" v-show="activetab == 19"> <!--Defects history-->
            <section class="internal-container border-top-table-fl">
                <app-asset-defect-tab v-if="assetDefectLoad" :assetDefectVal="assetDefectTabValue"></app-asset-defect-tab>
            </section>
          </div> <!--defect History-->

          <div id="comments" class="admin-page-content asset-view list-view" v-show="activetab == 17"> <!--Customer Comments-->
            <section class="internal-container border-top-table-fl">
                <app-asset-vehicle-comment-tab v-if="assetCommnetLoad" :vehicleCommentVal="vehicleCommentTabValue"></app-asset-vehicle-comment-tab>
            </section>
          </div>

          <div id="group-detail" class="admin-page-content asset-view list-view" v-show="activetab == 3"> <!--Group-->
            <section class="internal-container border-top-table-fl">
                <div class="form-row no-divider" v-if="assetGroupData">
                  <div class="col-md-6">
                      <div class="row form-group">
                        <label class="col"> Code: </label>
                        <span class="col"> {{titleCase(assetGroupData.code)}} </span>
                      </div>

                      <div class="row form-group">
                        <label class="col"> Manufacturer: </label>
                        <span class="col" v-if="assetGroupData.vmName || assetGroupData.vmCode">  {{assetGroupData.vmCode + " | " + titleCase(assetGroupData.vmName)}} </span>
                        <span class="col" v-else>-</span>
                      </div>

                      <div class="row form-group">
                        <label class="col"> Status: </label>
                        <span class="col" v-if="assetGroupData.status == 0"> Inactive </span>
                        <span class="col" v-else-if="assetGroupData.status == 1"> Active</span>
                        <span class="col" v-else> - </span>
                      </div>

                      <div class="row form-group">
                        <label class="col"> Type : </label>
                        <span class="col"> {{assetGroupData.vtCode +" | "+ titleCase(assetGroupData.vtName)}} </span>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="row form-group">
                        <label class="col"> Name: </label>
                        <span class="col"> {{titleCase(assetGroupData.name)}}
                        </span>
                      </div>

                      <div class="row form-group">
                        <label class="col"> Model: </label>
                        <span class="col"> {{titleCase(assetGroupData.vmodelsName )}} </span> </div>

                      <div class="row form-group">
                        <label class="col"> Year: </label>
                        <span class="col"> {{titleCase(assetGroupData.year)}} </span> </div>
                  </div>
                </div>
                <div v-else>No Data Found.</div>
            </section>
          </div> <!--Group-->

          <div id="permit-detail" class="admin-page-content asset-view list-view" v-show="activetab == 6"> <!--Permit-->
            <section class="internal-container border-top-table-fl">
                <app-permit-tab v-if="permitLoad" :permitValue="permitTabValue"></app-permit-tab>
            </section>
          </div> <!--Permit-->

          <div id="meter" class="admin-page-content asset-view list-view" v-show="activetab == 22"> <!--Defects history-->
            <section class="internal-container border-top-table-fl" v-show="!showAdd">
                <h3 class="fl-title"> Asset Meter</h3>
                <template v-if="!AddMeterFlag">
                  <div class="table-responsive-sm">
                    <table aria-describedby="table" class="table table-sm">
                        <thead>
                            <tr class="table-primary">
                                <th>Section</th>
                                <th>Read On WO</th>
                                <th>Read On Contract</th>
                            </tr>
                        </thead>
                        <tbody>
                          <template v-if="meterArr && meterArr.length > 0">
                            <tr v-for="(meter, index) in meterArr" :key="index">
                                <td>
                                  <span>{{meter.secCode}} | {{meter.sectionName}}</span>
                                </td>
                                <td>
                                    <span>{{titleCase(meter.read_on_wo)}}</span>
                                </td>
                                <td>
                                    <span>{{titleCase(meter.read_on_contract)}}</span>
                                </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td colspan="3" align="center">No metrics has been setup for the asset type of this asset.</td>
                            </tr>
                          </template>
                        </tbody>
                    </table>
                  </div>
                </template>
                <div class="btn-groups mt-4">
                <button type="submit" v-on:click.prevent="addMetric()" class="btn btn-primary">
                    <i class="fp-add"></i>Update Metric
                </button>
                </div>
            </section>
            <section class="internal-container border-top-table-fl" v-show="showAdd">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="metricForm">
                <div class="table-responsive-sm">
                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                      <thead>
                          <tr class="table-primary">
                              <th scope="col" class="w-50 require">Section</th>
                              <th scope="col" class="w-25 require">Read On Wo</th>
                              <th scope="col" class="w-25 require">Read On Contract</th>
                              <th scope="col">Action</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(read, mindex) in mrows" :key="mindex">
                              <td>
                                  <v-select class="section-id" v-model="read.section" name="rate_section" placeholder="Select Section Rate"
                                      label="text"
                                      :options="sectionArr">
                                  </v-select>
                                  <div class="field-error">{{ read.section_error_msg }}</div>
                              </td>
                              <td>
                                  <v-select class="section-id" v-model="read.read_on_wo" name="read_on_wo" placeholder="Select Read On Wo"
                                      label="text"
                                      :options="readOnArr">
                                  </v-select>
                                  <div class="field-error">{{ read.read_on_wo_error_msg }}</div>
                              </td>
                              <td>
                                  <v-select class="section-id" v-model="read.read_on_contract" name="read_on_contract" placeholder="Select Read On Contract"
                                      label="text"
                                      :options="readOnArr">
                                  </v-select>
                                  <div class="field-error">{{ read.read_on_contract_error_msg }}</div>
                              </td>
                              <td class="text-center valign-middle">
                                  <template>
                                        <a href="javascript:void(0)" v-on:click.prevent="removeMElement(mindex);"> <i class="fp-remove"></i> </a>
                                  </template>
                                  <!-- <template v-else>
                                      <span class="close-row"> _ </span>
                                  </template> -->
                              </td>
                          </tr>
                      </tbody>
                  </table>
                </div>
                <button type="submit" v-on:click.prevent="addMetricRow()" class="btn btn-primary">
                    <i class="fp-add"></i>Add Line Item
                </button>
                <div class="btn-groups mt-4">
                    <button type="submit" v-if="mrows.length > 0" id="CreateAllowanceBtn" class="btn btn-primary" v-on:click.prevent="createMeter('add')">
                        <i class="fp-reload"> </i> Update
                    </button>

                    <button type="submit" v-else id="CreateAllowanceBtn" class="btn btn-primary" v-on:click.prevent="createMeter('add')">
                        <i class="fp-save"> </i> Save
                    </button>
                    <button type="submit" id="CancelAllowanceBtn" class="btn btn-tertiary" v-on:click.prevent="cancelAdd">
                        <i class="fp-close"> </i> Cancel
                    </button>
                </div>
            </form>
            </section>
          </div> <!--Meter-->

          <div id="contract-history" class="admin-page-content" v-show="activetab == 5"> <!--Contract History-->
            <!-- <h2 class="tab-content-title"> Contract History </h2> -->
            <section class="internal-container border-top-table-fl">
              <div class="container">
                <div class="col-md-12 customer-view-main">
                  <app-asset-contract-tab v-if="assetConractLoad" :assetContractVal="contractTabValue"></app-asset-contract-tab>
                </div>
              </div>
            </section>
          </div> <!--Contract History-->

          <div id="asset-component" class="admin-page-content asset-view list-view" v-show="activetab == 7"> <!--Asset Component-->
            <section class="internal-container border-top-table-fl">
                <app-asset-component-tab v-if="assetComponentLoad" :assetComponentVal="contractComValue"></app-asset-component-tab>
            </section>
          </div> <!--Asset Component-->

          <div id="customer-contact" class="admin-page-content asset-view list-view" v-show="activetab == 9"> <!--Customer Contact-->
            <section class="internal-container border-top-table-fl">
                  <app-asset-customer-contact-tab v-if="enableCustContact" :listFlag="'assetCustomerContact'" :moduleId="assetId">
                  </app-asset-customer-contact-tab>
            </section>
          </div> <!--Customer Contact-->
          <!--Asset Standard Feature-->
           <!-- <div id="standard-feature" class="admin-page-content asset-view list-view" v-show="activetab == 11">
            <section class="internal-container border-top-table-fl">
              <app-asset-standard-feature-tab v-if="standardFeatureLoad" :assetStandardVal="standardFeatureVal"></app-asset-standard-feature-tab>
            </section>
          </div>  -->
          <!--Asset Standard Feature-->
          <div id="asset-warranties" class="admin-page-content asset-view list-view" v-show="activetab == 13"> <!--asset warranties-->
            <section class="internal-container border-top-table-fl">
                  <app-asset-warranty-tab v-if="warrantyLoad" :assetwarrantiesVal="assetWarrantyVal"></app-asset-warranty-tab>
            </section>
          </div>
          <div v-show="activetab == 24"> <!--asset warranties-->
            <vehicle-warranty-details @vehicle-warranty-data="handleVehicleWarrantyData" ref="vehicleWarrantyDetails"></vehicle-warranty-details>

          </div>
          <div id="work-orders" class="admin-page-content asset-view list-view" v-show="activetab == 14"> <!--Work Orders-->
            <section class="internal-container border-top-table-fl">
                <app-asset-work-order-tab v-if="workOrderLoad" :workOrderVal="workOrderVal"></app-asset-work-order-tab>
            </section>
          </div>
          <div id="work-orders" class="admin-page-content asset-view list-view" v-show="activetab == 26"> <!--Work Orders-->
            <section class="internal-container border-top-table-fl">
                <app-rental-agreement-list v-if="agreementLoad" :assetId="vehicleId"></app-rental-agreement-list>
            </section>
          </div>
          <div id="work-orders" class="admin-page-content asset-view list-view" v-show="activetab == 27"> <!--Work Orders-->
            <section class="internal-container border-top-table-fl">
                <app-contract-asset-detail-list v-if="contractLoad" :assetId="vehicleId"></app-contract-asset-detail-list>
            </section>
          </div>
          <div id="activity-logs" class="admin-page-content asset-view list-view" v-show="activetab == 15"> <!--Activity Logs-->
            <section class="internal-container border-top-table-fl">
              <div class="bg-white data-table p-0">
                <customer-activity-log-list :activityLogVal="activityLogsTabValue"></customer-activity-log-list>
             </div>
            </section>
          </div>
          <div id="asset-reading" class="admin-page-content asset-view list-view" v-show="activetab == 16"> <!--Meter Reading-->
            <section class="internal-container border-top-table-fl">
              <template v-if="!AddReadingFlag">
                  <!--div class="row">
                    <div class="col-11">
                      <data-table-filter-config :moduleName="'telematicListAssetView'"></data-table-filter-config>
                    </div>
                    <div class="col-1">
                      <div v-show="!AddReadingFlag" class="btn-groups text-right mb-3">
                            <button type="submit" id="addOdometerReading" v-on:click="addOdometerReading()" class="btn btn-primary">
                                <i class="fp-add"> </i>  Add
                            </button>
                      </div>
                    </div>
                  </div-->

                  <app-telematics-reading-list v-if="assetReadingLoad" :assetReadingVal="assetReadingVal" @addOdometerReading="addOdometerReading" ></app-telematics-reading-list>
              </template>
              <template v-else>
                  <app-telematics-reading-add :assetReadingTab="'addReading'" :assetId="vehicleId" :unitNo="unitNo" :assetName="name" :locationCode="locationCode" :assetTypeId="assetTypeId"></app-telematics-reading-add>
              </template>
            </section>
          </div>
          <div id="asset-extra-feature" class="admin-page-content asset-view list-view" v-show="activetab == 20"> <!--Extra Features-->
            <section class="internal-container border-top-table-fl">
                <app-extra-feature-tab v-if="extraFeatureLoad" :assetId="assetId"></app-extra-feature-tab>
            </section>
          </div>
          <div id="depreciation-schedule" class="admin-page-content asset-view list-view" v-show="activetab == 21"> <!--Depreciation Schedule-->
            <section class="internal-container border-top-table-fl">
                <asset-depreciation-list v-if="depreciationLoad" :scheduleVal="scheduleTabValue"></asset-depreciation-list>
            </section>
          </div> <!--Depreciation Schedule-->
          <div id="unit-cap-cost" class="admin-page-content" v-show="activetab == 23">
            <section class="internal-container purchase-order-btm bill-view-table border-top-table-fl">
              <!-- <div class="container"> -->
                <template v-if="capCostGLArr == undefined || capCostGLArr.length == 0">
                    <div class="row lineitem-main-section">
                    <h6>No Data Found</h6>
                    </div>
                </template>
                <template v-else>
                  <div class="table-responsive-sm">
                    <div class="border-radius">
                      <!-- <table aria-describedby="table" class="table table-sm table-bordered">
                        <thead>
                            <tr class="table-primary">
                                <th>Date</th>
                                <th>Reference</th>
                                <th>Account</th>
                                <th style="text-align: right;">Debit</th>
                                <th style="text-align: right;">Credit</th>
                                <th style="text-align: right;">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(capItem , capKey) in capCostGLArr">
                              <tr :key="'capcost'+capKey">
                                  <td>{{capItem.post_date}}</td>
                                  <td>{{capItem.reference}}</td>
                                  <td>{{capItem.gl_account}}</td>
                                  <td style="text-align: right;">{{capItem.debit}}</td>
                                  <td style="text-align: right;">{{capItem.credit}}</td>
                                  <td style="text-align: right;">{{capItem.amount}}</td>
                              </tr>
                            </template>
                        </tbody>
                      </table> -->
                      <table aria-describedby="table" class="table table-sm table-bordered">
                        <thead>
                            <tr class="table-primary">
                                <th>Transaction Date</th>
                                <th style="text-align: right;">Transaction Amount</th>
                                <th>General Ledger Code</th>
                                <th>Source Type</th>
                                <th>Source Document</th>
                                <th>Accounting Year</th>
                                <th>Accounting Period</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(capItem , capKey) in capCostGLArr">
                              <tr :key="'capcost'+capKey">
                                  <td>{{capItem.post_date}}</td>
                                  <td style="text-align: right;">{{capItem.amount}}</td>
                                  <td>{{capItem.gl_code}}</td>
                                  <td>{{capItem.document_type}}</td>
                                  <td>{{capItem.document_no}}</td>
                                  <td>{{capItem.year}}</td>
                                  <td>{{capItem.period}}</td>
                              </tr>
                            </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
              <!-- </div>     -->
            </section>
          </div>
          <div id="pm-unit-detail" class="admin-page-content asset-view list-view" v-show="activetab == 25"> <!--Depreciation Schedule-->
            <section class="internal-container border-top-table-fl">
                <pm-unit-detail-report v-if="pmDetailLoad" :PMVal="pmUnitDetailValue"></pm-unit-detail-report>
            </section>
          </div>
          <div id="program-interval-detail" class="admin-page-content asset-view list-view" v-show="activetab == 29"> <!--Group-->
            <section class="internal-container border-top-table-fl">
                <!-- <div class="form-row no-divider" v-if="assetGroupData"> -->
                  <div v-if="introws && introws.length > 0" class="table-responsive-sm">
                      <table aria-describedby="table" class="table table-sm table-bordered font-1">
                          <thead>
                              <tr class="table-primary">
                                  <th scope="col" >Asset</th>
                                  <th scope="col" >Asset Group</th>
                                  <th scope="col" >Program Name</th>
                                  <th scope="col" >Program Description</th>
                                  <th scope="col" >Interval Type</th>
                                  <th scope="col" >From Value</th>
                                  <th scope="col" >To Value</th>
                                  <th scope="col" >UOM</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(read, index) in introws" :key="index">
                                  <td><span>{{ read.vehicle_id }}</span></td>
                                  <td><span>{{ read.group_id }}</span></td>
                                  <td><span>{{ read.name }}</span></td>
                                  <td><span>{{ read.description }}</span></td>
                                  <td><span>{{ read.interval_type }}</span></td>
                                  <td><span>{{ read.from_value }}</span></td>
                                  <td><span>{{ read.to_value }}</span></td>
                                  <td><span>{{ read.uom_id }}</span></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-else>No Data Found.</div>
                <!-- </div> -->
            </section>
          </div> <!--Group-->
          <div id="work-orders" class="admin-page-content asset-view list-view" v-show="activetab == 30"> <!--Work Orders-->
            <section class="internal-container border-top-table-fl">
                <capital-cost-analysis-list v-if="capCostLoad" :assetId="vehicleId"></capital-cost-analysis-list>
            </section>
          </div>
          <div v-show="activetab == 'campaign'"> <!--asset campaign/recalls-->
            <vehicle-campaign-recall-details></vehicle-campaign-recall-details>
          </div>

        </div>
      </template>

      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer><!--tab content--><!--tab content-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import AssetContractView from '@/components/asset/AssetContracts';
// import AssetTelematicsReadingView from '@/components/telematicsReading/TelematicsReadingList'


import EventBus from "././event-bus";
import { dataTableMixins } from "../mixins/dataTableMixins";
import { commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';
// import PMUnitDetailReport from './reports/PMUnitDetailReport.vue';
// Vue.component("app-asset-contract-tab", AssetContractView);
// Vue.component("app-asset-telematicsreading-tab", AssetTelematicsReadingView);
// Vue.component("app-asset-customer-contact-tab", AssetCustomerContact);

export default {
  name: "AssetView",
  components: {

      appAssetVehicleCommentTab: () => import('@/components/asset/AssetComments'),
      //appAssetStandardFeatureTab: () => import('@/components/asset/AssetStandardFeature'),
      appAssetLogTab: () => import('@/components/asset/AssetLog'),
      //appAssetDefectTab: () => import('@/components/AssetDefectList'),
      appExtraFeatureTab: () => import('@/components/AssetExtraFeatureView'),
      appAssetTab: () => import('@/components/AssetTabView'),
      appAssetTabDealerView: () => import('@/components/AssetTabDealerView'),
      appAssetTabConsumerView: () => import('@/components/AssetTabConsumerView'),
      appAssetCustomerContactTab: () => import('@/components/CustomerContactList'),
      appPermitTab: () => import('@/components/PermitList'),
      appAssetWarrantyTab: () => import('@/components/asset/AssetWarranty'),
      //appAssetComponentTab: () => import('@/components/asset/AssetComponentList'),
      //appAssetContractTab: () => import('@/components/asset/AssetContracts'),
      appAssetWorkOrderTab: () => import('@/components/WorkOrderList'),
      appRentalAgreementList: () => import('@/components/RentalAgreementList'),
      appContractAssetDetailList: () => import('@/components/ContractAssetDetailList'),
      CustomerActivityLogList: () => import('@/components/ActivityLogList.vue'),
      appTelematicsReadingAdd: () => import('@/components/telematicsReading/TelematicsReadingCreate'),
      appAssetMeterCreate: () => import('@/components/asset/AssetMeterCreate'),
      appTelematicsReadingList: () => import('@/components/telematicsReading/TelematicsReadingList'),

      pmUnitDetailReport: () => import('@/components/reports/PMUnitDetailReport'),
      capitalCostAnalysisList: () => import('@/components/asset/CapitalCostAnalysisList'),
      vehicleDetails: () => import('@/components/VehicleDetails'),
      VehicleWarrantyDetails: () => import('@/components/VehicleWarrantyDetails'),
      VehicleCampaignRecallDetails: () => import('@/components/VehicleCampaignRecallDetails'),
  },
  mixins:[dataTableMixins,commonMixins,contractMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    locationTabValue:"dontLoadList",
    contractTabValue:"dontLoadList",
    contractComValue:"dontLoadList",
    telematicsReadingTabValue:"dontLoadList",
    //customerContactTabValue:"dontLoadList",
    enableCustContact:false,
    permitTabValue:'dontLoadList',
    vehicleCommentTabValue:'dontLoadList',
    standardFeatureVal:'dontLoadList',
    comWarrantyVal:'dontLoadList',
    assetWarrantyVal:"dontLoadList",
    workOrderVal:"dontLoadList",
    assetReadingVal:"dontLoadList",
    activityLogsTabValue: "dontLoadList",
    assetLogTabValue:"dontLoadList",
    assetDefectTabValue:"dontLoadList",
    assetExtraFeatureVal:"dontLoadList",
    assetData: [],
    assetGroupData: [],
    tabMenuArray:[],
    loading: false,
    loadTabView:false,
    activetab: 0,
    permit_value:false,
    agreementLoad:false,
    contractLoad:false,
    name:"",
    unitNo:"",

    assetColumns:[
        {
            label: 'Warranty',
            field: 'code',
            width:'auto',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Asset | Customer', // placeholder for filter input
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.columnFilterFn, //custom filter function that
                trigger: 'enter', //only trigger on enter not on keyup
            },
            sortable:true
        },
        {
            label: 'Description',
            field: 'description',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Description', // placeholder for filter input
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.columnFilterFn, //custom filter function that
                trigger: 'enter', //only trigger on enter not on keyup
            },
            sortable:true
        },
        {
            label: 'Type',
            field: 'warranty_type_id',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Type', // placeholder for filter input
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.columnFilterFn, //custom filter function that
                trigger: 'enter', //only trigger on enter not on keyup
            },
            sortable:true
        },
        {
            label: 'Starting Point',
            field: 'starting_point_value',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Starting Point', // placeholder for filter input
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.columnFilterFn, //custom filter function that
                trigger: 'enter', //only trigger on enter not on keyup
            },
            sortable:true
        },
        {
            label: 'Period',
            field: 'period',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Period', // placeholder for filter input
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.columnFilterFn, //custom filter function that
                trigger: 'enter', //only trigger on enter not on keyup
            },
            sortable:true
        },
        {
          label: 'Retail Delivery Date',
          field: 'date_of_sale',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'Warranty Start Date',
          field: 'date_in_service',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
    ],
    rows: [],
    totalRecords: 0,
    serverParams: {
        columnFilters: {},
        sort: {
            field: 'id',
            type: 'desc',
        },
        page: 1,
        perPage: 50
    },
    allowEditAsset:false,
    allowListAsset:false,
    assetFeatureRowCount:0,
    assetId:"",
    ownershipLoad:false,
    assetLogLoad:false,
    extraFeatureLoad:false,
    standardFeatureLoad:false,
    assetDefectLoad:false,
    assetCommnetLoad:false,
    assetReadingLoad:false,
    permitLoad:false,
    warrantyLoad:false,
    assetComponentLoad:false,
    workOrderLoad:false,
    assetConractLoad:false,
    AddReadingFlag:false,
    allowAssetgroup:false,
    allowViewasset:false,
    allowListassetownership:false,
    allowLogasset:false,
    allowAssetfeature:false,
    allowAssetcomment:false,
    allowAssetpermit:false,
    allowAddodometerreading:false,
    allowOdometerreadingreport:false,
    allowListwarranty:false,
    allowListCampaign: false,
    allowPmunitdetailreport:false,
    allowListcustomercontact:false,
    allowListrentalagreement:false,
    allowListcontractassetdetail:false,
    allowListworkorder:false,
    allowListassetdepreciation:false,
    allowListactivitylog:false,
    allowListcapitalcost:false,
    allowListprogram:false,
    allowGeneralledgerreport:false,
    scheduleTabValue:"dontLoadList",
    pmUnitDetailValue:"dontLoadList",
    locationCode:'',
    vehicleId:0,
    pageKey:"",
    depreciationLoad:false,
    AddMeterFlag:false,
    meterArr:[],
    currentContract:[],
    fromUrl:"",
    capCostGLArr:[],
    pmArr:[],
    pmDetailLoad:false,
    capCostLoad:false,
    showAdd:false,
    mrows:[],
    sectionArr:[],
    readOnArr:[{text:'Mandatory',value:'mandatory'}],
    assetTypeId:null,
    updateAddressFlag:false,
    addAddressFlag:false,
    unit_error:"",
    introws:[],
    isEnableAssetGroup:false,
	  isEnableAssetPool:false,

    tabMenuAssetOwner:false,
    tabMenuAssetDealer:false,
    tabMenuAssetConsumer:false,
    tabMenuAssetLogs:false,
    tabMenuAssetFeature:false,
    tabMenuAssetComment:false,
    tabMenuAssetPermit:false,
    tabMenuMeter:false,
    tabMenuMeterMetric:false,
    tabMenuCoverage:false,
    tabMenuWarranty:false,
    tabMenuPmUnitDetailReport:false,
    tabMenuCustomerContacts:false,
    tabMenuRentalAgreement:false,
    tabMenuContractAsset:false,
    tabMenuWorkOrder:false,
    tabMenuDepreciation:false,
    tabMenuCapitalCostGL:false,
    tabMenuActivityLogs:false,
    tabMenuAssetInterval:false,
    tabMenuCapitalCostAnalysis:false,
    canGenerateVehicleWarranty:false,

    hidefield:false,
    showfield:false,
    velocity_env:process.env.NODE_ENV,
    canViewComment: false,
    vin: '',
  }),
  metaInfo() {
      return {
          title: (this.vin != "") ? this.vin + " | Asset View | " +process.env.COPYRIGHT_NAME:"Asset View | " +process.env.COPYRIGHT_NAME
      }
  },
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (self.velocity_env == 'velev' || self.velocity_env == 'velev_test') {
            if (permissions[i].name == "ev_view_vehicle") {
              self.cantAccessPage = true;
              self.loadTabView = true;
              setTimeout(function () {
                $('.right-asset-tab-list').on('click', 'li', function () {
                  $('.right-asset-tab-list li.active').removeClass('active');
                  $(this).addClass('active');
                });
              }, 200);
            }
            if (permissions[i].name == "ev_add_vehicle") {
              self.allowEditAsset = true;
            }
            /////list permition ///
            if (permissions[i].name == "ev_list_vehicle_group") {
              self.allowAssetgroup = true;
            }
            if (permissions[i].name == 'ev_view_vehicle') {
              self.allowViewasset = true;
            }
            if (permissions[i].name == 'ev_view_vehicle') {
              self.tabMenuAssetDealer = true;
            }
            if (permissions[i].name == 'ev_view_vehicle') {
              self.tabMenuAssetConsumer = true;
            }
            if (permissions[i].name == 'ev_list_vehicle_ownership') {
              self.allowListassetownership = true;
            }

            if (permissions[i].name == 'ev_list_vehicle_location_history') {
              self.allowLogasset = true;
            }
            if (permissions[i].name == "ev_list_vehicle_feature") {
              self.allowAssetfeature = true;
            }
            if (permissions[i].name == "ev_view_vehicle_comment") {
              self.allowAssetcomment = true;
            }
            if (permissions[i].name == "ev_add_odometer_reading") {
              self.allowAddodometerreading = true;
            }
            if (permissions[i].name == "ev_odometer_reading_report") {
              self.allowOdometerreadingreport = true;
            }
            if (permissions[i].name == "ev_list_warranty") {
              self.allowListwarranty = true;
            }
            if (permissions[i].name == 'ev_list_campaign') {
              self.allowListCampaign = true;
            }
            if (permissions[i].name == "ev_pm_unit_detail_report") {
              self.allowPmunitdetailreport = true;
            }
            if (permissions[i].name == "ev_list_customer_contact") {
              self.allowListcustomercontact = true;
            }
            if (permissions[i].name == "ev_list_rental_agreement") {
              self.allowListrentalagreement = true;
            }
            if (permissions[i].name == "ev_list_contract_vehicle_detail") {
              self.allowListcontractassetdetail = true;
            }
            if (permissions[i].name == "ev_list_work_order") {
              self.allowListworkorder = true;
            }
            if (permissions[i].name == "ev_list_vehicle_depreciation") {
              self.allowListassetdepreciation = true;
            }
            if (permissions[i].name == "ev_list_program") {
              self.allowListprogram = true;
            }
            if (permissions[i].name == "ev_list_activity_log") {
              self.allowListactivitylog = true;
            }
            if (permissions[i].name == "ev_general_ledger_report") {
              self.allowGeneralledgerreport = true;
            }
            if (permissions[i].name == "ev_list_capital_cost") {
              self.allowListcapitalcost = true;
            }
            if (permissions[i].name == "ev_list_asset_permit") {
              self.allowAssetpermit = true;
            }
            if (permissions[i].name == "ev_generate_vehicle_warranty") {
              self.canGenerateVehicleWarranty = true;
            }
            if (permissions[i].name == "view_asset_comment"){
              self.canViewComment = true;
            }
          }
          else {
            if (permissions[i].name == "view_asset") {
              self.cantAccessPage = true;
              self.loadTabView = true;
              setTimeout(function () {
                $('.right-asset-tab-list').on('click', 'li', function () {
                  $('.right-asset-tab-list li.active').removeClass('active');
                  $(this).addClass('active');
                });
              }, 200);
            }
            if (permissions[i].name == "add_asset") {
              self.allowEditAsset = true;
            } else if (permissions[i].name == "list_asset") {
              self.allowListAsset = true;
            }
            /////list permition ///
            if (permissions[i].name == "list_asset_group") {
              self.allowAssetgroup = true;
            }
            if (permissions[i].name == 'view_asset') {
              self.allowViewasset = true;
            }
            if (permissions[i].name == 'view_asset') {
              self.tabMenuAssetDealer = true;
            }
            if (permissions[i].name == 'view_asset') {
              self.tabMenuAssetConsumer = true;
            }
            if (permissions[i].name == 'list_asset_ownership') {
              self.allowListassetownership = true;
            }

            if (permissions[i].name == 'list_asset_location_history') {
              self.allowLogasset = true;
            }
            if (permissions[i].name == "list_asset_feature") {
              self.allowAssetfeature = true;
            }
            if (permissions[i].name == "view_asset_comment") {
              self.allowAssetcomment = true;
            }
            if (permissions[i].name == "add_odometer_reading") {
              self.allowAddodometerreading = true;
            }
            if (permissions[i].name == "odometer_reading_report") {
              self.allowOdometerreadingreport = true;
            }
            if (permissions[i].name == "list_warranty") {
              self.allowListwarranty = true;
            }
            if (permissions[i].name == "pm_unit_detail_report") {
              self.allowPmunitdetailreport = true;
            }
            if (permissions[i].name == "list_customer_contact") {
              self.allowListcustomercontact = true;
            }
            if (permissions[i].name == "list_rental_agreement") {
              self.allowListrentalagreement = true;
            }
            if (permissions[i].name == "list_contract_asset_detail") {
              self.allowListcontractassetdetail = true;
            }
            if (permissions[i].name == "list_work_order") {
              self.allowListworkorder = true;
            }
            if (permissions[i].name == "list_asset_depreciation") {
              self.allowListassetdepreciation = true;
            }
            if (permissions[i].name == "list_program") {
              self.allowListprogram = true;
            }
            if (permissions[i].name == "list_activity_log") {
              self.allowListactivitylog = true;
            }
            if (permissions[i].name == "general_ledger_report") {
              self.allowGeneralledgerreport = true;
            }


            if (permissions[i].name == "list_capital_cost") {
              self.allowListcapitalcost = true;
            }
            if (permissions[i].name == "list_asset_permit") {
              self.allowAssetpermit = true;
            }
          }
        }
      }
    }
  },
  created: function() {},
  mounted: function() {

    var self = this;
    if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
      self.hidefield = true;
      self.showfield = true;
    }
    self.loadFieldData(['enable_asset_group','enable_asset_pool']);
    if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
      self.fromUrl = atob(self.$route.query.fromUrl);
    }
    var pathUrl = window.location.pathname;
    var segments = pathUrl.split("/");
    self.assetId = segments[3];
    self.pageKey='_vehicle_view_'+self.assetId;
    var path = window.location.href;

      var decodeStr = "";
      if ( self.$route.query.data != '' && this.$route.query.data != undefined ) {

          decodeStr = atob(this.$route.query.data)
          var url = new URL(path+"?"+decodeStr);
          var tabVal = url.searchParams.get("selectTab");
          if(tabVal == 17) {
              this.$nextTick(() => {
                  self.getCommentList()
              });
              setTimeout(function () {
                  $('.activetabs li.active').removeClass('active');
                  $('#activetab17').addClass("active");
              }, 3000);

          }
      }
      if(self.$route.params.viewTab == 'componentDetail'){
          setTimeout(function(){
              self.loadList();
              $("#tabActive li").removeClass("active");
              $('#component-detail').addClass("active");
          },2000);
      }

      setTimeout(function () {
          if(self.$route.params.selectTab == 4) {
              self.activetab = 4;
              $('.activetabs li.active').removeClass('active');
              $('#activetab4').addClass("active");
          }
      }, 1000);

      if(self.$route.params.selectTab == 20) {
          setTimeout(function () {
                  /* self.activetab = 20;*/
              $('.activetabs li.active').removeClass('active');
              $('#extraFeatureTab').addClass("active");
                  $('#extraFeatureTab').click();
                  self.extraFeaturesTabClicked();
              }
              , 1000);
      }


    self.getPermissions();
    if( self.$route.query.from && self.$route.query.from == 'owner'){
      // alert('ji')
      setTimeout(function(){

        $("#ownerShipTab").click();
        self.ownershipTabClicked();

      },1000);
    }
    if(self.$route.query.viewTab == 'permit') {
      this.$router.replace({ query: {} });
      setTimeout(function () {
          $("#tabActive li").removeClass("active");
          $('#permit').addClass("active");
          $('#permit').click();
          self.permitTabClicked();
      }
          , 2000);
    }
    if(self.$route.query.viewTab == 'workOrder') {
      this.$router.replace({ query: {} });
      setTimeout(function () {
          $("#tabActive li").removeClass("active");
          $('#workOrder').addClass("active");
          $('#workOrder').click();
          self.workOrder();
      }
          , 2000);
    }
  },
  methods: {
    handleClick(newTab) {
      var self = this;
      self.currentTab = newTab;
    },
    loadList(){
      var self = this;
      self.activetab = 7;
      self.assetComponentLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('load');
        self.contractComValue = "loadList";       // flag value set to loadList so that filters in list work properly.
      }

      // this.$root.$emit('load');
    },

    assetLogTabClicked(){
      var self = this;
      self.activetab = 18;
      self.assetLogLoad = true;
      if ( !self.tabMenuArray.includes(self.activetab) ) {
          self.tabMenuArray.push(self.activetab);
          // this.$root.$emit('asset_log_opted');
          self.assetLogTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      }
      // this.$root.$emit('location_history_opted');

    },

    loadAssetDefect() {

      var self = this;
      self.activetab = 19;
      self.assetDefectLoad = true;
      if ( !self.tabMenuArray.includes(self.activetab) ) {
          self.tabMenuArray.push(self.activetab);
          // this.$root.$emit('asset_defect_opted');
          self.assetDefectTabValue = "loadList";
      }

    },

    ownershipTabClicked(){
      var self = this;
      self.activetab = 10;
      self.ownershipLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('asset_ownership');    // flag value set to loadList so that filters in list work properly.
      }
    },

    dealerTabClicked(){
      var self = this;
      self.activetab = 31;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
      }
    },

    consumerTabClicked(){
      var self = this;
      self.activetab = 32;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
      }
    },

      extraFeaturesTabClicked(){
          var self = this;
          self.activetab = 20;
          self.extraFeatureLoad = true;
          if(!self.tabMenuArray.includes(self.activetab)){
              self.tabMenuArray.push(self.activetab);
              // this.$root.$emit('asset_extra_feature');    // flag value set to loadList so that filters in list work properly.
          }
      },

    contractHistoryTabClicked(){
      var self = this;
      self.activetab=5;
      self.assetConractLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('contract_history_opted');
        self.contractTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      }
      // this.$root.$emit('contract_history_opted');
    },

    permitTabClicked(){
      var self = this;
      self.activetab = 6;
      self.permitLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('load_permit');
        self.permitTabValue = "loadList";         // flag value set to loadList so that filters in list work properly.
      }
      // this.$root.$emit('permit_opted');
    },

    customerContactTabClicked(){
      var self = this;
      self.activetab=9;
      self.enableCustContact = true;
       if(!self.tabMenuArray.includes(self.activetab)) {
        self.tabMenuArray.push(self.activetab);
        //this.$root.$emit('customer_contact');
        //self.customerContactTabValue = "laodList";    // flag value set to loadList so that filters in list work properly.
      }
      // this.$root.$emit('customer_contact_opted');
    },
    standardFeatures(){
      var self = this;
      self.activetab = 11;
      self.standardFeatureLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)) {
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('standard_features');
        self.standardFeatureVal = "loadList";     // flag value set to loadList so that filters in list work properly.
      }
    },

    assetWarranty(){
      var self = this;
      self.activetab = 13;
      self.warrantyLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        self.assetWarrantyVal = "loadList";     // flag value set to loadList so that filters in list work properly.
        // this.$root.$emit('asset_warranty');
      }
    },
    warranties(){
      var self = this;
      self.activetab = 24;
      // self.warrantyLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
      }
    },
    getAssetWarranties() {

       var self = this;
       self.loading = true;

        $.ajax({
          url: process.env.ROOT_API + "/warranty/asset/" + self.assetId,
          type: "POST",
          headers: this.ajxHeaders,
          dataType: "json",
          success: function(data) {
            console.log(data)
            self.loading = false;
            if (data.status == "success") {
              console.log("result ==", data);
              self.rows = data.content.row;
              if (self.rows === undefined){
                self.rows = [];
              }

            }
          },
          error: function(jqXHR, exception) {
            self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'asset-load-view')

          }
        });


    },
    generateVehicleWarranty() {

      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/generate-vehicle-warranty/" + self.assetId,
        type: "POST",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function(data) {
          // self.loading = false;
          if (data.status == "success") {
            const delay = 1000;
            self.activetab = 24;
            $("#tabActive li").removeClass("active");
            $('#activetab24').addClass("active");
            if(!self.tabMenuArray.includes(self.activetab)) {
              self.tabMenuArray.push(self.activetab);
            }

            setTimeout(() => {
              self.getAssetWarranties();
            }, delay);
            self.$refs.vehicleWarrantyDetails.getAssetWarranties(self.assetId);
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,true,'asset-load-view')

        }
      });


    },
    getActivityLog(){
      var self = this;
      self.activetab = 15;
      var path = window.location.pathname;
      var segments = path.split("/");
      if(!self.tabMenuArray.includes(self.activetab)){
        // self.tabMenuArray.push(self.activetab);
        this.$root.$emit('activity_log_opted','asset',segments[3]);
        self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
      }
    },

    getReadingList(){
      var self = this;
      self.activetab = 16;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('reading_opted');
        self.assetReadingVal = "loadList";     // flag value set to loadList so that filters in list work properly.
        self.assetReadingLoad = true;
      }
    },
    removeMElement: function (index) {
        var self = this;
        // if (self.mrows.length > 1) {
            self.mrows.splice(index, 1);
            self.createMeter('remove');
            // if(!self.mrows.length){
            //   self.mrows.push({
            //     section: '',
            //     section_error_msg:'',
            //     read_on_wo: '',
            //     read_on_wo_error_msg:'',
            //     read_on_contract: '',
            //     read_on_contract_error_msg:'',
            //   });
            // }
        // }
    },
    createMeter:function(from){
      var self = this;
      var secArr = [];
      var error = false;
      var path = window.location.pathname;
      var segments = path.split("/");

      for (var j=0;j<self.meterArr.length;j++){
        if (self.meterArr[j].from == undefined || self.meterArr[j].from != 'asset'){
          secArr.push(self.meterArr[j].secCode.toLowerCase());
        }
      }

      for (var i=0;i<self.mrows.length;i++){
         if (self.mrows[i].section == null || self.mrows[i].section == '' || !self.mrows[i].section) {
              self.mrows[i].section_error_msg = "Section is Required.";
              error = true;
          }

          if (self.mrows[i].read_on_wo == null || self.mrows[i].read_on_wo == '' || !self.mrows[i].read_on_wo) {
              self.mrows[i].read_on_wo_error_msg = "Read On WO is Required.";
              error = true;
          }

          if (self.mrows[i].read_on_contract == null || self.mrows[i].read_on_contract == '' || !self.mrows[i].read_on_contract) {
              self.mrows[i].read_on_contract_error_msg = "Read On Contract is Required.";
              error = true;
          }

          if (self.mrows[i].section.code != undefined){
            if (secArr.includes(self.mrows[i].section.code.toLowerCase())){
              self.mrows[i].section_error_msg = "Section is Already Added for Unit Type.";
              error = true;
            }
          }
          secArr.push(self.mrows[i].section.code);
      }

      if (error){
        return;
      }

      $.ajax({
        url: process.env.ROOT_API + "/asset-meter/create",
        type: "POST",
        // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
        data: {
          meter:JSON.stringify(self.mrows),
          id:segments[3]
        },
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {

            self.loading = false;
            if (from != 'remove'){
              self.$swal('','Metric Added Successfully','success');
            }
            self.loadAssetView();
            setTimeout(function () {
              $('.activetabs li.active').removeClass('active');
              $('#assetTypeMeterTab').addClass("active");
                  $('#assetTypeMeterTab').click();
              self.showAdd = false;

              }
              , 1000);
        },
        error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'asset-type-meter-create')
        }
    });
    },
    cancelAdd:function(){
      var self = this;
      self.mrows = [];
      self.showAdd = false;
    },
    addMetric: function () {
      var self = this;

      self.loadFieldData(['section']);

      if (self.mrows.length < 1){
        if (self.meterArr.length){
          for (var j=0;j<self.meterArr.length;j++){
            if (self.meterArr[j].from != undefined && self.meterArr[j].from == 'asset'){
            var arrData = self.meterArr;
                self.mrows.push({
                  section:{text:arrData[j].sectionName+' ('+arrData[j].secCode+')',value:arrData[j].section_id,code:arrData[j].secCode},
                  read_on_wo:{text:self.titleCase(arrData[j].read_on_wo),value:arrData[j].read_on_wo},
                  read_on_contract:{text:self.titleCase(arrData[j].read_on_contract),value:arrData[j].read_on_contract},
              })
            }
          }
        }

        self.mrows.push({
          section: '',
          section_error_msg:'',
          read_on_wo: '',
          read_on_wo_error_msg:'',
          read_on_contract: '',
          read_on_contract_error_msg:'',
        });
      }

      self.showAdd = true;
    },
    addMetricRow: function () {

        var self = this;
        var i = self.mrows.length - 1;
        var error = false;
        self.mrows[i].section_error_msg = "";
        self.mrows[i].read_on_wo_error_msg = "";
        self.mrows[i].read_on_contract_error_msg = "";

        if (self.mrows[i].section != null && self.mrows[i].section != '' && self.mrows[i].section.value && self.mrows[i].read_on_wo != null &&
            self.mrows[i].read_on_wo != '' && self.mrows[i].read_on_wo.value && self.mrows[i].read_on_contract != null &&
            self.mrows[i].read_on_contract != '' && self.mrows[i].read_on_contract.value) {

                self.mrows.push({
                    section: '',
                    section_error_msg:'',
                    read_on_wo: '',
                    read_on_wo_error_msg:'',
                    read_on_contract: '',
                    read_on_contract_error_msg:'',
                });

        } else{
            if (self.mrows[i].section == null || self.mrows[i].section == '' || !self.mrows[i].section) {
                self.mrows[i].section_error_msg = "Section is Required.";
                error = true;
            }

            if (self.mrows[i].read_on_wo == null || self.mrows[i].read_on_wo == '' || !self.mrows[i].read_on_wo) {
                self.mrows[i].read_on_wo_error_msg = "Read On WO is Required.";
                error = true;
            }

            if (self.mrows[i].read_on_contract == null || self.mrows[i].read_on_contract == '' || !self.mrows[i].read_on_contract) {
                self.mrows[i].read_on_contract_error_msg = "Read On Contract is Required.";
                error = true;
            }
        }
    },
    getAssetMeter(){
      var self = this;
      self.activetab = 22;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        // this.$root.$emit('reading_opted');
      }
    },
      getCommentList(){
          var self = this;
          self.activetab = 17;
          self.assetCommnetLoad = true;
          if(!self.tabMenuArray.includes(self.activetab)){
              self.tabMenuArray.push(self.activetab);
              // this.$root.$emit('load_vehicle_comment');
              self.vehicleCommentTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
          }
      },
      workOrder(){
          var self = this;
          self.activetab = 14;
          self.workOrderLoad = true;
          if(!self.tabMenuArray.includes(self.activetab)){
              self.tabMenuArray.push(self.activetab);
              // this.$root.$emit('work_order');
              self.workOrderVal = "loadList";   // flag value set to loadList so that filters in list work properly.
          }
      },

    getCustomerAgreement(){
          var self = this;
          self.activetab = 26;
          self.agreementLoad = true;
          if(!self.tabMenuArray.includes(self.activetab)){
              self.tabMenuArray.push(self.activetab);
              // this.$root.$emit('work_order');
              // self.workOrderVal = "loadList";   // flag value set to loadList so that filters in list work properly.
          }
      },

      getContractAsset(){
          var self = this;
          self.activetab = 27;
          self.contractLoad = true;
          if(!self.tabMenuArray.includes(self.activetab)){
              self.tabMenuArray.push(self.activetab);
              // this.$root.$emit('work_order');
              // self.workOrderVal = "loadList";   // flag value set to loadList so that filters in list work properly.
          }
      },

      loadAssetView() {

        var self = this;

        $.ajax({
          url: process.env.ROOT_API + "/asset/" + self.assetId,
          type: "GET",
          headers: this.ajxHeaders,
          data:{
            action_flag : 'view', // pass action for notify: view, edit
            is_notify_flag : true // notify if user viewing or editing
          },
          dataType: "json",
          success: function(data) {
            console.log(data)
            self.loading = false;
            if (data.status == "success") {
              self.updateAddressFlag = false;
              self.vehicleId = data.content.id;
              self.name = data.content.name;
              self.unitNo = data.content.unit_no;
              self.assetData = data.content;
              console.log('Asset DATA=>',self.assetData);
              self.currentContract = data.content.current_contract;
              self.locationCode = data.content.locCode;
              var storeObject={visited_page: {
                                path : "Asset |" +self.unitNo,
                                data : window.location.pathname,
                            }};
              self.getRecentlyPagesMethod(storeObject);
              if(self.assetData.extra_features != '' && self.assetData.extra_features!=null)
              {
                  self.assetFeatureRowCount=Math.round(self.assetData.extra_features.length / 2);
              }

              self.meterArr = data.content.metric;
              var vehMetricArr = [];
              self.mrows = [];
              if (data.content.metric != undefined && data.content.metric.length > 0){
                for (var i=0;i < data.content.metric.length ; i++){
                  if (data.content.metric[i].from != undefined && data.content.metric[i].from == 'asset'){
                    var arrData = data.content.metric;
                     self.mrows.push({
                        section:{text:arrData[i].sectionName+' ('+arrData[i].secCode+')',value:arrData[i].section_id,code:arrData[i].secCode},
                        read_on_wo:{text:self.titleCase(arrData[i].read_on_wo),value:arrData[i].read_on_wo},
                        read_on_contract:{text:self.titleCase(arrData[i].read_on_contract),value:arrData[i].read_on_contract},
                    })
                  }
                }
              }
              if (data.content.cap_cost_gl != undefined) {
                self.capCostGLArr = data.content.cap_cost_gl;
              }else{
                self.capCostGLArr = [];
              }
              self.assetTypeId = data.content.vehicle_type_id;

            }
          },
          error: function(jqXHR, exception) {
            self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'asset-load-view')

          }
        });
    },
      loadVehicleGroup(group_id) {
        // alert(group_id);
          var path = window.location.pathname;
          var segments = path.split("/");
          var self = this;
          self.activetab=3;
          if(!self.tabMenuArray.includes(self.activetab) && group_id != null && group_id > 0){
            self.tabMenuArray.push(self.activetab);
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/assetgroup/" + group_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        // assetGroupData
                        self.assetGroupData = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-view-group-data');

                }
            });
          }

      },
    loadProgramInterval(asset) {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.introws = [],
        self.activetab= 29;
        self.tabMenuArray.push(self.activetab);
          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/programinterval/view/" + segments[3],
              type: "GET",
              headers: this.ajxHeaders,
              data: {
                vehicle_id: asset.id,group_id : asset.vehicle_group_id
              },
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if (data.status == "success") {

                    var arrData = data.content.row;
                      if (arrData){
                          for (var i = 0; i < arrData.length; i++){
                              var intervalType = '';
                              for(var l =0;l < self.intervalTypeArr.length;l++){
                                  if (self.intervalTypeArr[l].value == arrData[i].interval_type){
                                      intervalType = self.intervalTypeArr[l].text;
                                      console.log(self.intervalTypeArr[l]);
                                  }
                              }
                              self.introws.push({
                                  vehicle_id: arrData[i].vehicle_id,
                                  group_id: arrData[i].group_id,
                                  description:arrData[i].description,
                                  name:arrData[i].name,
                                  interval_id:arrData[i].interval_id,
                                  interval_type:intervalType,
                                  from_value: arrData[i].from_value,
                                  to_value:arrData[i].to_value,
                                  uom_id:(arrData[i].uom_id != '')?arrData[i].uom:'',
                              })
                          }
                      }
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'asset-view-group-data');

              }
          });
    },
    getCapitalCost(){
        var self = this;
        self.activetab = 30;
        self.capCostLoad = true;
        if(!self.tabMenuArray.includes(self.activetab)){
            self.tabMenuArray.push(self.activetab);
            // this.$root.$emit('work_order');
            // self.workOrderVal = "loadList";   // flag value set to loadList so that filters in list work properly.
        }
      },
    updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
        this.updateParams({page: params.currentPage});
        if (this.firstLoad == 1){
          this.loadPermit();
        }
    },
    onPerPageChange(params) {
        var self = this;
        this.updateParams({perPage: params.currentPerPage});
        this.totalRecords = self.totalRecords;

        if( self.totalRecords < (params.currentPerPage * this.serverParams.page) ) {
            this.updateParams({page: 1});
        } else {

            this.updateParams({page: params.currentPage});
        }
        if (this.firstLoad == 1){
            this.loadPermit();
        }
    },

    onColumnFilter(params) {
        this.updateParams(params);
        var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
        var filters = filtersPr.columnFilters;
        if (this.firstLoad == 1 || filters.name || filters.is_default) {
            this.loadPermit();
        }
    },
    selectionChanged(param) {
        var self = this;
        if(param.selectedRows.length == 100) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }
        // console.log(self.computed.selectedRows);
        // var rowData = self.$refs['my-table'].selectedRows;
        // console.log(rowData);
    },
    onSortChange(params) {
        this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
        });
        this.loadPermit();
    },
    getWarranties(){

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      var id = 'jfhelnhhlnlcbhkemeaggbdpmihhohkg';
      var isChromium = window.chrome,
      winNav = window.navigator,
      vendorName = winNav.vendor;
      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc.") {

        let routeData = self.$router.resolve({name: 'OwlWarranty', params: {id: segments[3]}});
        window.open(routeData.href, '_blank');

        // self.UrlExist('chrome-extensions://jfhelnhhlnlcbhkemeaggbdpmihhohkg',function(status){

        //     if(status == 200){
        //       console.log('exist');

        //       // var string = "&vehicle_id="+segments[3];

        //       let routeData = self.$router.resolve({name: 'OwlWarranty', params: {id: segments[3]}});
        //       window.open(routeData.href, '_blank');
        //     }else{
        //       self.$swal('','Please Install the extension first','info');
        //     }
        // });
      } else {
        self.$swal('','Please use Chrome browser to import warranty using VTRL chrome extension','info');
      }
    },
    UrlExist:function(url,cb){

        $.ajax({
                url: url,
                type: "GET",
                dataType: 'text',
                headers: this.ajxHeaders,
                complete: function(xhr){

                    if( typeof cb === 'function')
                    cb.apply(this,[xhr.status]);
                }
        })

    },
    addOdometerReading(){
      var self = this;
      self.AddReadingFlag = true;
    },
    addAssetMeterReadingList(){
      var self = this;
      self.AddMeterFlag = false;
    },
    addAssetMeterReading(){
      var self = this;
      self.AddMeterFlag = true;
    },
    showOdometerReadingList(){
      var self = this;
      self.AddReadingFlag = false;
    },
    depreciationSchedule:function(){
      var self = this;
      self.activetab = 21;
      self.depreciationLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        self.scheduleTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
      }
    },
    backButton() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        if(segments[1] == "available-vehicle"){
            var url = "/available-vehicles/list"
        }else if(segments[1] == "my-vehicles"){
            var url = "/my-vehicles/list"
        }else if(segments[1] == "all-vehicles"){
            var url = "/all-vehicles/list"
        }else if(segments[1] == "warranty-claim"){
            var url = "/warranty-claim/queue"
        }else{
          var url = "/asset/list";
        }
        if ( self.fromUrl != "" && self.fromUrl != undefined ) {
            url = self.fromUrl;
        }
        if(this.$route.query.from != undefined && this.$route.query.from == 'gl'){
            self.$router.push('/report/general-ledger');
        }else if(this.$route.query.from != undefined && this.$route.query.from == 'permit'){
            self.$router.push('/vehiclepermit/list');
        }else if(this.$route.query.from != undefined && this.$route.query.from == 'available-vehicles'){
            self.$router.push('/available-vehicles/list');
        }else if(this.$route.query.from != undefined && this.$route.query.from == 'my-vehicles'){
            self.$router.push('/my-vehicles/list');
        }else if(this.$route.query.from != undefined && this.$route.query.from == 'asset-list'){
            self.$router.push('/all-vehicles/list');
        }else if(this.$route.query.from != undefined && this.$route.query.from == 'warranty-claim'){
            self.$router.push('/warranty-claim/queue');
        }else{
            self.redirectPageUrl(url);
        }
    },
    downloadInv() {
      var self = this;
      console.log(self.assetId);
      if(self.assetId != null && self.assetId != ''){
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/asset-sale-invoice",
          type: "POST",
          crossDomain: true,
          headers: {
              'Accept': 'application/json',
              "Access-Control-Allow-Origin": '*',
              "Authorization": "Bearer "+localStorage.getItem("tkn"),
              'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
              "Cache-Control": "no-cache"
          },
          dataType: "json",
          data: {
            id: self.assetId,
          },
          success: function(data) {
            self.loading = false;
            console.log(data.content);
            if (data.status == "success" && data.code == 200 && data.content != '') {
              var link = document.createElement('a');
              document.body.appendChild(link);
              link.href = data.content;
              link.download = '';
              link.target = "_blank";
              link.click();
            } else {
              self.$swal('','Invoice Not Found','info');
            }
          },
          error: function(jqXHR, exception) {
            self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'asset-sale-invoice');
          }
        });
      }

    },
    capitalCostTab() {
      var self = this;
      self.activetab = 23;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
      }
    },

    pmDetail() {
      var self = this;
      self.activetab = 25;
      self.pmDetailLoad = true;
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
        self.pmUnitDetailValue = 'loadList'
        // self.programAssetDetail();
      }
    },
    editCustomerAddress:function(){
        var self = this;

        self.addAddressFlag = true;
    },
    addunit(){
      var self = this;
      var error = false;
      console.log(self.assetId);
      self.unit_error= "";
      if (self.assetData.unit_no == null || self.assetData.unit_no == ''){
        self.unit_error = 'Unit Required';
        error = true;
      }
      if (!error) {
        console.log(self.assetData.unit_no);
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/update/unit",
            type: "POST",
            data: {unitno: self.assetData.unit_no, id: self.assetId},
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              if (data.code == 200) {
                self.addAddressFlag = false;
              }else{
                self.unit_error = data.message;
                self.addAddressFlag = true;
              }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'asset-load-view')

            }
        });
      }
    },
    campaignRecalls(){
      var self = this;
      self.activetab = "campaign";
      if(!self.tabMenuArray.includes(self.activetab)){
        self.tabMenuArray.push(self.activetab);
      }
    },
    handleVehicleData(vehicleData){
      this.vin = vehicleData.vin;
    },
    handleVehicleWarrantyData(warrantyData){
      this.rows = warrantyData;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/AssetView.vue